var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Svg } from './Svg';
var UtilityGasIcon = function (props) { return (React.createElement(Svg, __assign({}, props),
    React.createElement("g", null,
        React.createElement("path", { strokeLinejoin: "round", strokeWidth: "1.5", d: "M11.5008867,22 C7.65505341,22 4.00088674,19.007762 4.00088674,15.3169193 C3.95621926,12.4410964 5.60269956,9.84407791 8.11755341,8.82363818 C8.21868636,8.77953403 8.33401519,8.79508947 8.42173783,8.86466628 C8.50946048,8.9342431 8.55684639,9.0477441 8.54672007,9.16402975 C8.37088248,10.6021924 8.88659605,12.0379708 9.91755341,12.9805143 C10.1580144,13.1983218 10.5125948,13.1902955 10.7442201,12.9618017 C11.8442201,11.8773605 14.5417201,8.29522927 9.72505341,2.55758175 C9.63796763,2.45401435 9.62008882,2.30355061 9.68018576,2.17998657 C9.7402827,2.05642252 9.86575084,1.98567416 9.99505341,2.00244052 C14.5183867,2.59678916 19.0008867,8.05374729 19.008867,13.3119951 C19.0008867,17.7673823 16.5008867,22 11.5008867,22 Z M15.5392201,13.9803032 C15.6153265,16.1083577 14.0674281,17.9013778 12.0775534,17.9901516" })))); };
export var UtilityGas = styled(UtilityGasIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
//# sourceMappingURL=UtilityGas.js.map